export function convertPxToPc(widthPx, container) {
  return widthPx / container * 100;
}
export function convertPcToPx(widthPc, container) {
  return container / 100 * widthPc;
}